import { Typography } from '@mui/material';
import SimpleProfileCard from '../../components/SimpleProfileCard/SimpleProfileCard';

import './AgentUserDetailsCard.scss';

function AgentUserDetailsCard({agentName, email, phone, city, state, managerPictureURL, manager, children}) {
  return (
    <div className="agent-user-details-card">
      <div className="user-info">
        <div className="user-info-item">
          <Typography variant="label" component="label" className="section-title">Nome</Typography>
          <Typography variant="p" component="p">{agentName}</Typography>
        </div>
        <div className="user-info-item">
          <Typography variant="label" component="label" className="section-title">Email</Typography>
          <Typography variant="p" component="p">{email}</Typography>
        </div>
        <div className="user-info-item">
          <Typography variant="label" component="label" className="section-title">Telefone</Typography>
          <Typography variant="p" component="p">{phone}</Typography>
        </div>
        <div className="user-info-item">
          <Typography variant="label" component="label" className="section-title">Cidade</Typography>
          <Typography variant="p" component="p">{city} - {state}</Typography>
        </div>
      </div>
      <div className="manager-info">
        <div className="user-info-item">
          <Typography variant="label" component="label" className="section-title">Supervisor</Typography>
          <SimpleProfileCard
            className=""
            userName={manager}
            userPictureURL={managerPictureURL}
          />
        </div>
      </div>
      {children}
    </div>
  );
}

export default AgentUserDetailsCard;